<template>
  <div class="mechines bg-secondary">
    <h1 class="">Devices</h1>
    <input
      id="searchDeviceID"
      v-model="searchTerm"
      class="form-control mb-3"
      placeholder="Search DeviceID..."
      style="width: 300px; margin-bottom: 20px; margin-left: 10px; display: inline-block;"
      type="text"
    />
    <table class="table table-hover table-dark" id="myTable">
      <thead>
        <tr>
          <th scope="col">#</th>
          <th scope="col">DeviceID</th>
          <th scope="col">WiFiRSSI</th>
          <th scope="col">WiFiSSID</th>
          <th scope="col">LastSeen</th>
          <th scope="col">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(device, index) in pagedDevices" :key="device.DeviceId || index">
          <th scope="row">{{ (page - 1) * pageSize + index + 1 }}</th>
          <td style="text-transform: uppercase;">{{ device.DeviceId }}</td>
          <td>{{ device.WiFiRSSI }}</td>
          <td>{{ device.WiFiSSID }}</td>
          <td>{{ new Date(device.DateTimeUTC + "Z").toLocaleString('en-GB')}} </td>
          <td>
            <button class="btn btn-info btn-sm" @click="goToDetails(device.DeviceId)"><i class="fa fa-eye"></i></button>
          </td>
        </tr>
      </tbody>
    </table>
    <Pagination :total="filteredDevices.length" :page-size="pageSize" v-model="page" />
  </div>
</template>

<script>
import moment from 'moment'
import axios from 'axios'
import Pagination from '../common/Pagination.vue'
export default {
  components: { Pagination },
  data () {
     return {
       deviceList: [],
       searchTerm: '',
       page: 1,
       pageSize: 15,
     }
  },

   mounted() {
     this.getAllDevices()
   },

watch: {
    // reset to the first page whenever the search changes
    searchTerm() {
      this.page = 1
    }
  },

computed: {
    filteredDevices() {
      if (!this.searchTerm) return this.deviceList;
      const normalizedSearch = this.searchTerm.replace(/:/g, '').toLowerCase();
      return this.deviceList.filter(device => {
        const normalizedId = (device.DeviceId || '').replace(/:/g, '').toLowerCase();
        return normalizedId.includes(normalizedSearch);
      });
    },
    pagedDevices() {
      const start = (this.page - 1) * this.pageSize
      return this.filteredDevices.slice(start, start + this.pageSize)
    }
  },
methods: {
    //USE MOMENT
    getLocalTime(date) {
    return moment(date).format('YYYY-MM-DD HH:mm:ss')
  },
  getAllDevices() {
       axios.get('https://m4a.ramacsystems.com/backend/devices/GetDevices.php')
         .then((response) => {
          this.deviceList = response.data
       })
          .catch(error => console.log(error))
  },
    goToDetails(DeviceId) {
      this.$router.push('/deviceComm/' + DeviceId)
    }
 } 
}
</script>

<style scoped>
.mechines,
h1,
td,
th {
    color: #fff;
}

h1 {
    float: left;
    margin-left: 10px;
    text-transform: uppercase;
    font-size: 20px;
}

#addMechine {
  float: right;
  margin-right: 90px;
}

a {
  text-decoration: none;
}

nav {
	font-family: monospace;
}

li {
	color: #fff;
	display: block;
	float: left;
  margin-left: 0px;
	padding: 1px;
	position: relative;
	text-decoration: none;
  transition-duration: 0.5s;
}
  
li {
  color: #fff;
}


ul li ul{
	background: rgb(37, 37, 37);
	visibility: hidden;
  opacity: 0;
	position: absolute;
  transition: all 0.5s ease;
  margin-top: 1px;
  display: none;
}

ul li ul li a {
  color:#fff;
  float: right;
  margin-left: -10px;
}
ul li:hover > ul,
ul li ul:hover {
  visibility: visible;
  opacity: 1;
  display: block;
}

ul li ul li {
	clear: both;
  width: 100%;
}

#searchDeviceID {
  width: 300px;
  float: right;
}
</style>
